// Unpublished Work © 2022 Deere & Company

import {
    RESET_DBS_CUSTOMER_PROFILE,
    SET_DBS_CUSTOMER_PROFILE_MODAL_STATUS
} from '../../action-list';

const setCustomerProfileModalStatus = (state, action) => action.showDBSCustomerDetailsModal;

const resetProfileStatus = () => false;

export function showDBSCustomerDetailsModal(state = false, action = {}) {
    const actionHandlers = {
        [SET_DBS_CUSTOMER_PROFILE_MODAL_STATUS]: setCustomerProfileModalStatus,
        [RESET_DBS_CUSTOMER_PROFILE]: resetProfileStatus
    };

    const reducer = actionHandlers[action.type];

    return reducer ? reducer(state, action) : state;
}
